import { GET_MATCHING_ALLERGIES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface AllergiesSuggestions {
    id: string;
    name: string;
}

export default (text?: string): Promise<AllergiesSuggestions[]> =>
    fetchWithRefresh(GET_MATCHING_ALLERGIES(text || '')).then((res) => res.json());
